export default __webpack_public_path__ + "exportPDF.png";